import { createSlice } from "@reduxjs/toolkit";
import { ReactionsProps } from "./Reactions";

const initialState: ReactionsProps.State = {
  reactions: {},
  getSystemCuratedReactionTypes_API_STATUS: "idle",
  addReactionToAPost_API_STATUS: "idle",
  getTotalReactionsForAPost_API_STATUS: "idle",
  updateAReactionToAPost_API_STATUS: "idle",
  removeAReactionFromAPost_API_STATUS: "idle",
};

const slice = createSlice({
  name: "reactions",
  initialState,
  reducers: {
    setSystemCuratedReactionTypes: (
      state,
      action: ReactionsProps.setSystemCuratedReactionTypes
    ) => {
      state.reactions = action.payload || {};
    },
    setGetSystemCuratedReactionTypes_API_STATUS: (
      state,
      action: ReactionsProps.setGetSystemCuratedReactionTypes_API_STATUS
    ) => {
      state.getSystemCuratedReactionTypes_API_STATUS = action.payload;
    },
    setAddReactionToAPost_API_STATUS: (
      state,
      action: ReactionsProps.setAddReactionToAPost_API_STATUS
    ) => {
      state.addReactionToAPost_API_STATUS = action.payload;
    },
    setGetTotalReactionsForAPost_API_STATUS: (
      state,
      action: ReactionsProps.setGetTotalReactionsForAPost_API_STATUS
    ) => {
      state.getTotalReactionsForAPost_API_STATUS = action.payload;
    },
    setUpdateAReactionToAPost_API_STATUS: (
      state,
      action: ReactionsProps.setUpdateAReactionToAPost_API_STATUS
    ) => {
      state.updateAReactionToAPost_API_STATUS = action.payload;
    },
    setRemoveAReactionFromAPost_API_STATUS: (
      state,
      action: ReactionsProps.setRemoveAReactionFromAPost_API_STATUS
    ) => {
      state.removeAReactionFromAPost_API_STATUS = action.payload;
    },
  },
});

export const reactionsActions = slice.actions;
export const reactionsReducer = slice.reducer;
